import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { ActionBackOfficeResponse } from '../../../models/api.model';
import {
  EvChargingJobTableDto,
  EvChargingJobTableQuery,
  UpdateEvChargingJobStatusPayload,
} from '../../../models/cityparking/ev-charging-jobs.model';

@Injectable({ providedIn: 'root' })
export class ApiEvChargingJobsService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  getEvChargingJobsForTable(query: EvChargingJobTableQuery): Observable<EvChargingJobTableDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = {
      siteId: query.siteId,
      userId: query.userId,
      startDate: query.startDate,
      endDate: query.endDate,
      page: query.page ?? 1,
      pageSize: query.pageSize ?? 20,
      // Always send so primary chip reloads server-side; omit only when 'all' (API treats null as all).
      ...(query.jobStatus && query.jobStatus !== 'all' ? { jobStatus: query.jobStatus } : {}),
    };

    return this.apiMethodService.request<EvChargingJobTableDto>(
      '/backoffice/getEvChargingJobsForTable',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getEvChargingJobsForTable',
        token,
        headerOnly: false,
        params,
      }
    );
  }

  updateEvChargingJobStatus(payload: UpdateEvChargingJobStatusPayload): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/updateEvChargingJobStatus',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'updateEvChargingJobStatus',
        token,
        headerOnly: false,
        body: payload,
      }
    );
  }
}
